export default __webpack_public_path__ + "static/media/rocket_anim_142.d6981fce.png";